/** @jsxImportSource @emotion/react */
import React from 'react'
import { SerializedStyles } from '@emotion/react'

interface CanlanLogoIconProps {
  height?: number
  style?: SerializedStyles
}

/**
 * Canlan logo icon component (mobile version)
 * Maintains aspect ratio of 18:24 (width:height)
 */
const CanlanLogoIcon: React.FC<CanlanLogoIconProps> = ({
  height = 24,
  style,
}) => {
  // Calculate width to maintain aspect ratio (18:24)
  const width = (height * 18) / 24

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 24'
      fill='none'
      css={style}
    >
      <path
        d='M17.091 16.2231C17.091 16.2231 15.7132 15.4525 13.241 14.6949C11.2372 14.0574 9.18159 13.6415 7.07303 13.4447C6.56943 13.3905 6.04935 13.3458 5.51397 13.3116C10.2618 9.67194 14.966 7.66889 14.966 7.66889L15.3237 3.94557C11.0854 2.47392 7.47898 0.363647 7.47898 0.363647L7.65901 4.78096C8.62386 5.23577 9.53576 5.63403 10.3653 5.97926C7.82256 7.35194 4.40674 9.61539 0.36377 13.3128C0.36377 13.3128 0.413189 13.7075 1.16625 17.2187C4.48911 16.6873 8.35441 17.0043 11.6467 17.9787C9.86523 18.4948 8.26733 19.435 8.26733 19.435L8.47795 23.8182C11.9503 21.3415 16.6286 20.3376 16.6286 20.3376L16.9804 17.2117L17.091 16.2243V16.2231Z'
        fill='#0F56FA'
      />
    </svg>
  )
}

export default CanlanLogoIcon
